import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Button, ButtonSize } from '@cian/button-component';
import { Checkbox } from '@cian/checkbox-component';
import { Link } from '@cian/link-component';
import { PasswordField } from '@cian/password-field-component';
import { VisualSize } from '@cian/text-field-component';
import * as React from 'react';
import { EAuthenticateStatus } from '../../../../types/authentication';
import { EActiveView } from '../../../../types/view';
import * as styles from './styles.css';
import { trackForgotPasswordClick } from '../../../../utils/tracking';
export var LoginForm = /*#__PURE__*/function (_React$Component) {
  _inherits(LoginForm, _React$Component);

  var _super = _createSuper(LoginForm);

  function LoginForm(props) {
    var _this;

    _classCallCheck(this, LoginForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handlePasswordValueChange", function (password) {
      _this.setState({
        isChanged: true,
        isPasswordInvalid: false
      });

      _this.props.changePassword(password);
    });

    _defineProperty(_assertThisInitialized(_this), "handlePersistentValueChange", function (persistent) {
      _this.setState({
        isChanged: true,
        persistent: persistent
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleForgotPasswordClick", function (event) {
      event.preventDefault();
      var _this$props = _this.props,
          authenticateStatus = _this$props.authentication.authenticate.status,
          changeView = _this$props.changeView;
      trackForgotPasswordClick();

      if (![EAuthenticateStatus.Loading, EAuthenticateStatus.Succeed].includes(authenticateStatus)) {
        changeView(EActiveView.Restore);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmitClick", function (event) {
      event.preventDefault();
      var _this$props$authentic = _this.props.authentication,
          password = _this$props$authentic.password,
          status = _this$props$authentic.authenticate.status;

      if ([EAuthenticateStatus.Loading, EAuthenticateStatus.Succeed].includes(status)) {
        return;
      }

      var persistent = _this.state.persistent;

      if (!password) {
        _this.setState({
          isPasswordInvalid: !password
        });

        return;
      }

      _this.setState({
        isChanged: false
      });

      _this.props.authenticate(persistent);
    });

    _this.state = {
      persistent: true,
      isChanged: !!props.authentication.authenticate.error,
      isPasswordInvalid: false
    };
    return _this;
  }

  _createClass(LoginForm, [{
    key: "render",
    value: function render() {
      var _this$props$authentic2 = this.props.authentication,
          password = _this$props$authentic2.password,
          authenticateStatus = _this$props$authentic2.authenticate.status;
      var _this$state = this.state,
          isChanged = _this$state.isChanged,
          isPasswordInvalid = _this$state.isPasswordInvalid,
          persistent = _this$state.persistent;
      var isDisabled = [EAuthenticateStatus.Loading, EAuthenticateStatus.Succeed].includes(authenticateStatus);
      var isError = authenticateStatus === EAuthenticateStatus.Failed && !isChanged;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: styles['password_row']
      }, /*#__PURE__*/React.createElement(PasswordField, {
        placeholder: "\u041F\u0430\u0440\u043E\u043B\u044C",
        name: "password",
        maxLength: 255,
        inputStyle: styles['password_input'],
        invalid: isError || isPasswordInvalid,
        value: password,
        onValueChange: this.handlePasswordValueChange,
        size: VisualSize.MEDIUM,
        disabled: isDisabled
      })), /*#__PURE__*/React.createElement("div", {
        className: styles['special_row']
      }, /*#__PURE__*/React.createElement(Checkbox, {
        value: persistent,
        onValueChange: this.handlePersistentValueChange,
        label: "\u0417\u0430\u043F\u043E\u043C\u043D\u0438\u0442\u044C \u043C\u0435\u043D\u044F",
        disabled: isDisabled
      }), /*#__PURE__*/React.createElement(Link, {
        className: styles['forgot_password'],
        href: "#",
        onClick: this.handleForgotPasswordClick
      }, "\u0417\u0430\u0431\u044B\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?")), /*#__PURE__*/React.createElement("div", {
        className: styles['submit_row']
      }, /*#__PURE__*/React.createElement(Button, {
        type: "submit",
        block: true,
        size: ButtonSize.M,
        isSync: isDisabled,
        onClick: this.handleSubmitClick
      }, "\u0412\u043E\u0439\u0442\u0438")));
    }
  }]);

  return LoginForm;
}(React.Component);